import React from 'react';
import { FormattedMessage } from 'react-intl';


const CardComparisonOtherInformationSection = {
    sectionId: 'other-information',
    sectionLabel: (
        <FormattedMessage
            id="edb.cc.side-by-side-v2.other-information"
            defaultMessage="Other Information"
        />
    ),
    items: [
        {
            cardPropertyKey: 'otherPerks',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.other-perks"
                    defaultMessage="Other Perks"
                />
            ),
        },
    ],
};

export default CardComparisonOtherInformationSection;
